export default __webpack_public_path__ + "static/media/paint-01 (1).079ec1dd.jpg";